<template>
  <div class="withdraw md-layout md-alignment-center-center">

    <div class="container-header">
      <div class="container-header__title">{{ i18n.topup_refill() }}</div>
    </div>

    <template v-if="state">
      <md-card
        class="container
          container_40
          withdraw__success-msg
          md-layout-item
          md-size-50
          md-medium-size-45
          md-small-size-100
          md-xsmall-size-100"
      >
        <div class="md-title">{{ i18n.topup_request() }}</div>
        <div>
          <div class="withdraw__success-amount">
            {{ getTopUpRequestStatus }}
          </div>
          <md-button
            class="btn md-primary"
            @click="$router.push('/topup-balance/make') "
          >
            {{ i18n.lbl_go_back() }}
          </md-button>
          <md-button
            :to="'/history'"
            class="btn md-primary"
          >
            {{ i18n.lbl_view_history() }}
          </md-button>
        </div>
      </md-card>
    </template>

    <template v-else>
      <!-- Main screen -->
      <template v-if="view.mode === VIEW_MODES.submit && tokenCodes.length">
        <template
          v-if="isCryptoToken(form.tokenCode)"
        >
          <!-- Crypto -->
          <md-card class="container container_40">
            <div class="withdraw__user-balance text_medium">
              <p class="bold">
                {{ i18n.lbl_current_balance({ amount: greyWhiteTronSum, asset: formatToken }) }}
              </p>
              <p>{{i18n.white_wallet()}}: {{ swimBalance }} {{ formatToken }}</p>
              <p>{{i18n.gray_wallet()}}: {{ greyTronValue }} {{ formatToken }}</p>
            </div>
            <div>
              <p class="withdraw__explanations text_large">
                <template v-if="minAmounts[form.tokenCode]">
                  {{ i18n.topup_how_much({ asset: formatToken, value: minAmounts[form.tokenCode] }) }}.
                  {{ i18n.topup_crypto_minimal() }}
                </template>
                <template v-else>
                  {{  i18n.topup_network_fee()  }}
                </template>
              </p>
              <div class="md-layout withdraw__flex-wrapper">
                <select-field3
                  class="md-layout-item withdraw__select"
                  :label="i18n.lbl_choose_asset()"
                  :values="tokensCodeFormatted"
                  v-model="form.tokenCode"
                />
              </div>

              <template v-if="currentQr && !cryptoAddres">
                <div class="wrapform">
                  <div class="wrapform-w">
                    <div class="timer-wrap">
                      <Timer/>
                    </div>
                    <div class="app__dialog-inner" style="justify-content: center;">
                      <clipboard-field
                        class="account-id__clipboard"
                        :value="currentQr"
                      />
                    </div>
                    <button
                      class="md-button btn md-primary create-btn md-button-small"
                      @click="resetQrByBtn"
                      type="button"
                      v-if="createBtn"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">
                          {{ i18n.lbl_create_btn() }}
                        </div>
                      </div>
                    </button>
                  </div>
                  <div>
                    <div class="md-layout withdraw__flex-wrapper" style="justify-content: center;">
                      <p class="cash-header">{{ i18n.lbl_your_wallet() }}</p>
                    </div>
                    <qrcode
                      :style="'width: 250px; height: 250px; overflow: hide; margin: 0px auto !important;'"
                      :text="currentQr"
                      :size="250"
                      color="#3f4244"
                      :align="'center'"
                      />
                  </div>
                </div>
              </template>

              <template
                v-else-if="cryptoAddres !== '' && !noAddres"
              >
                <div
                  class="md-layout withdraw__flex-wrapper"
                  style="justify-content: center;"
                >
                  <p class="cash-header">{{ i18n.lbl_your_wallet() }}</p>
                </div>
                <div class="app__dialog-inner" style="justify-content: center;">
                  <div class="qrcode-wrap">
                    <qrcode
                      :style="'width: 250px; height: 250px; overflow: hide; margin: 0px auto !important;'"
                      :text="cryptoAddres"
                      :size="250"
                      color="#3f4244"
                      :align="'center'"
                    />
                    <clipboard-field
                      class="account-id__clipboard"
                      :value="cryptoAddres"
                    />
                  </div>
                </div>
              </template>

              <template
                v-else-if="noAddres"
              >
                <div class="md-layout withdraw__flex-wrapper" style="justify-content: center;">
                  <p class="cash-header">{{ i18n.lbl_no_data() }}</p>
                </div>
              </template>
              <template v-else>
                <div class="md-layout withdraw__flex-wrapper" style="justify-content: center;">
                  <p class="cash-header">{{ i18n.lbl_loading() }}</p>
                </div>
              </template>
            </div>
          </md-card>
        </template>

        <template v-else>
          <!-- Fiat -->
          <form
            class="
              md-layout-item
              md-size-50
              md-medium-size-75
              md-small-size-95
              md-xsmall-size-100"
            @submit.prevent="submit"
          >
            <md-card class="container container_40">
              <md-progress-bar md-mode="indeterminate" v-if="isPending"/>
              <div class="withdraw__user-balance text_medium">
                {{ i18n.lbl_current_balance({ amount: roundCurrency(balance !== undefined ? balance.balance : 0, form.tokenCode), asset: assetIcon(form.tokenCode) }) }}
              </div>
              <div>
                <p class="withdraw__explanations text_large">
                  <template v-if="minAmounts[form.tokenCode]">
                    {{ i18n.topup_how_much({ asset: form.tokenCode, value: minAmounts[form.tokenCode] }) }}.
                    {{ i18n.topup_minimal() }}.
                  </template>
                  <template v-else>
                    {{  i18n.topup_network_fee()  }}
                  </template>
                </p>
                <div class="md-layout withdraw__flex-wrapper">
                  <select-field3
                    id="wow"
                    class="md-layout-item withdraw__select"
                    :label="i18n.lbl_choose_asset()"
                    :values="tokensCodeFormatted"
                    v-model="form.tokenCode"
                  />

                  <div class="md-layout-item withdraw__field">
                    <input-field class="field__number"
                      v-model.trim="form.amount"
                      :label="i18n.lbl_amount()"
                      name="amount"
                      type="number"
                      title="Amount"
                      align="right"
                      vvValidateOn="change"
                      v-validate="'required|amount'"
                      :errorMessage="errors.first('amount') ||
                        (lessThenMinimumAmount
                          ? i18n.topup_error_minimum_amount({
                            value: minAmounts[form.tokenCode], asset: form.tokenCode })
                          : '')"
                      @blur="checkAmount"
                    />
                  </div>
                </div>
                <div
                  v-if="form.tokenCode === CRYPTO_CURRENCYS.ETH || form.tokenCode === CRYPTO_CURRENCYS.BTC"
                >
                  <input-field
                    class="md-layout-item"
                    v-model.trim="form.wallet"
                    :label="getDirections(TOP_UP_BALANCE_DIRECTION.external)"
                    name="wallet-address"
                    v-validate="'required|wallet_address'"
                    :errorMessage="errors.first('wallet-address') ||
                      (isTryingToSendToYourself ? i18n.topup_error_is_trying_to_send_to_yourself() : '')"
                  />
                </div>
                <div v-else-if="form.tokenCode === 'UAH' && (userTaurus.length > 0 || userUplataInsha.length > 0 || userXpay.length > 0)">
                  <select-field
                    class="md-layout-item"
                    :label="isEmptyCard ? i18n.topup_add_xpay_card() : i18n.topup_withdraw()"
                    v-model="form.direction"
                    name="direction"
                    title="direction"
                    :disabled="isEmptyCard"
                    :values="directionList"
                  />
                </div>
                <div v-else-if="isCashable">
                  <input-field
                    class="md-layout-item"
                    v-model.trim="form.direction"
                    name="direction"
                    :readonly="true"
                    :value="getDirections(TOP_UP_BALANCE_DIRECTION.cashbox)"
                  />
                </div>
                <div v-else>
                  <input-field
                    class="md-layout-item"
                    v-model.trim="form.direction"
                    name="direction"
                    :readonly="true"
                    :value="getDirections(TOP_UP_BALANCE_DIRECTION.nothere)"
                  />
                </div>
              </div>
              <div class="btn-wrap">
                <md-button
                  type="submit"
                  :disabled="!isCashable || isEmptyCard"
                  class="btn md-primary md-yellow w-100">{{ i18n.topup_topup() }}
                ></md-button>
              </div>
            </md-card>
          </form>
        </template>
      </template>

      <template v-if="view.mode === VIEW_MODES.success">
        <md-card
          class="withdraw__success-msg
            md-layout-item
            md-size-50
            md-medium-size-45
            md-small-size-100
            md-xsmall-size-100"
        >
          <div class="md-title">{{ i18n.topup_success() }}</div>
          <div class="btn-wrap">
            <div class="withdraw__success-amount">
              {{ this.normalizeAmount() }} {{ form.tokenCode }}
            </div>
            <md-button class="btn md-primary" @click="updateView(VIEW_MODES.submit, {} , true)">
              {{ i18n.lbl_go_back() }}
            </md-button>
            <md-button :to="'/history/index/' + form.tokenCode" class="btn md-primary">
              {{ i18n.lbl_view_history() }}
            </md-button>
          </div>
        </md-card>
      </template>

      <template v-if="view.mode === VIEW_MODES.otpConfirm">
        <md-card
          class="withdraw__success-msg
            md-layout-item
            md-size-50
            md-medium-size-45
            md-small-size-100
            md-xsmall-size-100"
        >
          <div class="md-title">{{ i18n.topup_otp_code_confirm() }}</div>
        </md-card>
      </template>

      <template v-if="view.mode === VIEW_MODES.secureConfirm">
        <md-card
          class="withdraw__success-msg
            md-layout-item
            md-size-50
            md-medium-size-45
            md-small-size-100
            md-xsmall-size-100"
        >
          <div class="md-title">{{ i18n.topup_success() }}</div>
          <div>
            ...............
            <div v-html="view.opts.form"></div>
          </div>
        </md-card>
      </template>

      <template v-if="!tokenCodes.length">
        <md-card
          class="md-layout-item
            md-size-50
            md-medium-size-65
            md-small-size-95
            md-xsmall-size-100"
        >
          <div class="container__no-data">
            <md-icon class="md-size-4x">credit_card</md-icon>
            <div class="text_large">{{ i18n.topup_no_assets() }}</div>
            <div class="text_description text_margin text_medium">
              {{ i18n.topup_no_assets_exp() }}
            </div>
          </div>
        </md-card>
      </template>
    </template>

  </div>
</template>

<script>
import formMixin from '@com/mixins/form.mixin'
import debounce from 'lodash/debounce'

import SelectField from '@com/fields/SelectField'
import SelectField3 from '@com/fields/SelectField3'
import InputField from '@com/fields/InputField'
import ClipboardField from '@com/fields/ClipboardField'
import ConfirmTopupBalance from './TopupBalance.Confirm'
import Timer from '../../timer/Timer'

import { mapGetters, mapActions } from 'vuex'
import { vuexTypes } from '@vuex/types'

import { i18n } from '@js/i18n'
import { feeService } from '@api/fees.service'
import { topUpService } from '@api/topup.service'
import { usersService } from '@api/users.service'
import { limitsService } from '@api/limits.service'
import { EventDispatcher } from '@js/events/event_dispatcher'
import { errors } from '@js/errors/factory'
import CurrencyRound from '@com/mixins/currency.round.mixin'
import { CurrencyHelper } from '@js/helpers/currency.helper'
// import { withdrawUSDTService } from '@api/withdraw_usdt.service'

import { XPAY_NON_VISIBLE_TYPE } from '@const'
import Qrcode from 'vue-qrcode-component'
import { mapMutations } from 'vuex/dist/vuex.common.js'
import { CRYPTO_CURRENCYS, QR_KEY_BY_NETWORK, getTokenNetwork, isNetworkToken, isCryptoToken, formatTokenCode, sortAssetCodes } from '@utils/consts'

const VIEW_MODES = {
  submit: 'submit',
  otpConfirm: 'otp-confirm',
  secureConfirm: 'secure-confirm',
  success: 'success'
}

const TOP_UP_BALANCE_DIRECTION = {
  nothere: 0,
  ucash: 1,
  cashbox: 2,
  external: 4,
  uplataInsha: 8,
  xpay: 16
}

const XPAY_OPERATION_PROCESSING = 102
const XPAY_OPERATION_CODE_SUCCESS = 200

const XPAY_OPERATION_STATUS_OTP = 3
const XPAY_OPERATION_STATUS_3DSECURE = 2

export default {
  name: 'TopupBalance-make',
  mixins: [formMixin, CurrencyRound],
  components: { SelectField, InputField, ConfirmTopupBalance, ClipboardField, Qrcode, Timer, SelectField3 },
  props: {
    state: '',
    xrayOperationID: ''
  },
  data: _ => ({
    TOP_UP_BALANCE_DIRECTION,
    publicPath: process.env.TOP_UP_CALL_BACK,
    directionList: [],
    topUpRequestStatus: [
      {code: '1', msg: i18n.topup_secure_msg_status_1()},
      {code: '2', msg: i18n.topup_secure_msg_status_2()},
      {code: '3', msg: i18n.topup_secure_msg_status_3()},
      {code: '4', msg: i18n.topup_secure_msg_status_4()},
      {code: '5', msg: i18n.topup_secure_msg_status_5()},
      {code: '6', msg: i18n.topup_secure_msg_status_6()},
      {code: '7', msg: i18n.topup_secure_msg_status_7()},
      {code: '10', msg: i18n.topup_secure_msg_status_10()},
      {code: '20', msg: i18n.topup_secure_msg_status_20()},
      {code: '21', msg: i18n.topup_secure_msg_status_21()}
    ],
    form: {
      tokenCode: null,
      amount: '',
      wallet: '',
      withdrawal_type: '',
      direction: 0
    },
    cryptoAddres: '',
    noAddres: false,
    view: {
      mode: VIEW_MODES.submit,
      opts: {}
    },
    minAmounts: {
      BTC: '0.00001',
      ETH: '0.01',
      UAH: '1.00',
      USDTTRC20: '10.00',
      USDTERC20: '10.00',
      USDTBEP20: '10.00'
    },
    maxAmounts: {
      BTC: '9999999999999999',
      ETH: '9999999999999999',
      UAH: '9999999999999999'
    },
    feesDebouncedRequest: null,
    subwallets: null,
    remainder: 0,
    i18n,
    VIEW_MODES,
    CRYPTO_CURRENCYS
  }),
  async created () {
    if (!this.isProductionEnv) {
      this.minAmounts.USDTTRC20 = '1.00'
      this.minAmounts.USDTERC20 = '1.00'
      this.minAmounts.USDTBEP20 = '1.00'
    }
    this.loadXpay().then(() => {
      this.directionList = this.getDirections(TOP_UP_BALANCE_DIRECTION.cashbox | TOP_UP_BALANCE_DIRECTION.ucash | TOP_UP_BALANCE_DIRECTION.uplataInsha | TOP_UP_BALANCE_DIRECTION.xpay)
    }).catch(error => console.log(error))
    await this.loadBalances()
    // await this.getSubWallets()
    this.setTokenCode()
    this.setDefaultDirection(this.form.tokenCode)
    // if (!this.isHasMain) {
    //   await this.createWallet()
    // }
  },
  computed: {
    ...mapGetters([
      vuexTypes.userWithdrawableTokens,
      vuexTypes.userCashTokens,
      vuexTypes.accountDepositAddresses,
      vuexTypes.accountBalances,
      vuexTypes.userTaurus,
      vuexTypes.userXpay,
      vuexTypes.userUplataInsha,
      vuexTypes.accountSignerName,
      vuexTypes.kfy,
      vuexTypes.accountId,
      vuexTypes.isProductionEnv
    ]),
    swimBalance () {
      const amount = this.balance !== undefined ? this.balance.balance : 0
      if (isCryptoToken(this.form.tokenCode)) {
        return this.roundCurrency2(amount, this.form.tokenCode)
      }
      return this.roundCurrency(amount, this.form.tokenCode)
    },
    greyTronValue () {
      if (isCryptoToken(this.form.tokenCode) && this.accountBalances[`${this.form.tokenCode}D`]) {
        return this.roundCurrency2(this.accountBalances[`${this.form.tokenCode}D`].balance)
      }
      return this.roundCurrency2(0)
    },
    greyWhiteTronSum () {
      const white = this.accountBalances[this.form.tokenCode]
      const grey = this.accountBalances[`${this.form.tokenCode}D`]
      if (isCryptoToken(this.form.tokenCode) && white && grey) {
        return this.roundCurrency2(+white.balance + +grey.balance)
      }
      return this.roundCurrency2(white ? +white.balance : 0)
    },
    createBtn () {
      return this.$store.state.timer.btn
    },
    isTimerLoading () {
      return this.$store.state.timer.isLoading
    },
    timer () {
      return this.$store.state.timer.timer
    },
    currentQr () {
      const qrCodes = this.$store.state.timer.qrCodes
      if (!qrCodes) return null
      // Deposit addresses are per-network: all tokens of a network share one address
      const network = getTokenNetwork(this.form.tokenCode)
      return (network && qrCodes[QR_KEY_BY_NETWORK[network]]) || null
    },
    getTopUpRequestStatus () {
      const msg = this.topUpRequestStatus.find(obj => obj.code === this.state)
      return msg ? msg.msg : i18n.topup_secure_msg_status_21()
    },
    tokenCodes () {
      return this.userWithdrawableTokens.map(token => token.code).filter(el => !el.endsWith('20D'))
    },
    formatToken () {
      return isNetworkToken(this.form.tokenCode) ? formatTokenCode(this.form.tokenCode) : this.assetIcon(this.form.tokenCode)
    },
    tokensCodeFormatted () {
      if (this.tokenCodes) {
        return sortAssetCodes(this.tokenCodes).map(el => ({key: el, val: formatTokenCode(el)}))
      }
      return []
    },
    tokenCashCodes () {
      return this.userCashTokens.map(token => token.code).filter(el => !el.endsWith('20D'))
    },
    balance () {
      return this.accountBalances[this.form.tokenCode]
    },
    isTryingToSendToYourself () {
      return this.form.wallet === this.accountDepositAddresses[this.form.tokenCode]
    },
    lessThenMinimumAmount () {
      return this.form.amount !== '' ? Number(this.form.amount) < this.minAmounts[this.form.tokenCode] : false
    },
    commissions () {
      const name = this.accountSignerName
      return name ? name.toLowerCase().startsWith('commission', 0) : false
    },
    isAllowedToSubmit () {
      return !(this.isFeesLoadPending || this.isTryingToSendToYourself || this.lessThenMinimumAmount)
    },
    isEmptyCard () {
      return (this.getDirections(TOP_UP_BALANCE_DIRECTION.cashbox | TOP_UP_BALANCE_DIRECTION.ucash | TOP_UP_BALANCE_DIRECTION.uplataInsha | TOP_UP_BALANCE_DIRECTION.xpay).length <= 0)
    }
    // isHasMain () {
    //   if (this.subwallets) {
    //     let arr = this.subwallets.filter(wallet => wallet.Description === 'main')
    //     .map(el => el.Asset)
    //     let el = arr.find(el => el === this.form.tokenCode)
    //     if (el) {
    //       return true
    //     }
    //     return false
    //   }
    //   return false
    // }
  },
  methods: {
    isCryptoToken,
    ...mapActions({
      loadBalances: vuexTypes.GET_ACCOUNT_BALANCES,
      loadXpay: vuexTypes.GET_USER_XPAY,
      startTimer: 'startTimer'
    }),
    ...mapMutations({
      clearTimer: 'clearTimer'
    }),
    // async createWallet () {
    //   await withdrawUSDTService.createSubWallet({
    //     user_id: this.accountId,
    //     asset: this.form.tokenCode,
    //     description: 'main',
    //     client_name: 'main'
    //   })
    //   await this.getSubWallets()
    // },
    // async getSubWallets () {
    //   const {_parsedData: res} = await withdrawUSDTService.getSubWallets({
    //     user_id: this.accountId
    //   })
    //   this.subwallets = res
    //   this.subwallets = this.subwallets.map(el => {
    //     return {
    //       ...el,
    //       Balance: el.Balance / 1000000
    //     }
    //   })
    // },
    async resetQr () {
      this.clearTimer()
      await this.startTimer({
        reactivateWallet: false,
        needCheckForm: true
      })
    },
    async resetQrByBtn () {
      this.clearTimer()
      await this.startTimer({
        reactivateWallet: true,
        needCheckForm: true
      })
    },
    b64DecodeUnicode (str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))
    },
    isCashable () {
      return (this.userCashTokens.map(token => token.code)).includes(this.form.tokenCode)
    },
    async submit () {
      if (!this.isAllowedToSubmit) return
      this.disableLong()
      try {
        const options = this.composeOptions()
        if (this.isFeesLoadFailed) {
          EventDispatcher.dispatchShowErrorEvent('Failed to load fees')
          return false
        }
        let result = await topUpService.createTopUpRequest(options)
        if (result._parsedData.Code === XPAY_OPERATION_PROCESSING) {
          if (result._parsedData.Data.OperationStatus === XPAY_OPERATION_STATUS_OTP) {
            this.view.mode = VIEW_MODES.otpConfirm
          } else if (result._parsedData.Data.OperationStatus === XPAY_OPERATION_STATUS_3DSECURE) {
            this.view.opts.form = this.b64DecodeUnicode(result._parsedData.Data['3dsHtml'])
            this.view.mode = VIEW_MODES.secureConfirm
            await this.$nextTick()
            const secureForm = document.getElementById('acs')
            secureForm.submit()
          }
        } else if (result._parsedData.Code === XPAY_OPERATION_CODE_SUCCESS) {
          this.view.mode = VIEW_MODES.success
        } else {
          throw new errors.TransactionError(i18n.unexpected_error())
        }
        await this.loadBalances()
      } catch (error) {
        console.error(await error.toLocaleString())
        error.showBanner(i18n.unexpected_error())
      }
      this.enable()
      this.errors.clear()
    },
    normalizeAmount () {
      if (this.form.tokenCode === 'UAH') {
        return Math.floor(parseFloat(this.form.amount)).toString() + '.00'
      }
      return this.form.amount
    },
    checkAmount () {
      this.form.amount = this.roundCurrency(this.form.amount, this.form.tokenCode)
    },
    composeOptions () {
      let xpayType = ''
      if (this.directionOf(this.TOP_UP_BALANCE_DIRECTION.ucash, this.form.direction) !== -1) {
        xpayType = 'taid'
      } else if (this.directionOf(this.TOP_UP_BALANCE_DIRECTION.uplataInsha, this.form.direction) !== -1) {
        xpayType = 'uplata insha'
      } else if (this.directionOf(this.TOP_UP_BALANCE_DIRECTION.xpay, this.form.direction) !== -1) {
        xpayType = 'xpay'
      }
      return {
        balance: this.balance !== undefined ? this.balance.balance_id : null,
        amount: this.normalizeAmount(),
        externalDetails: {
          address: this.form.wallet,
          withdrawalType: xpayType,
          displayName: this.form.direction,
          callbackUrl: process.env.TOP_UP_CALL_BACK
        },
        destAsset: this.form.tokenCode,
        expectedDestAssetAmount: this.normalizeAmount(),
        fee: {
          fixed: this.roundCurrency(this.fixedFee, this.form.tokenCode),
          percent: this.roundCurrency(this.percentFee, this.form.tokenCode)
        }
      }
    },
    getDirections (ids) {
      let dirs = []
      if ((ids & this.TOP_UP_BALANCE_DIRECTION.xpay) === this.TOP_UP_BALANCE_DIRECTION.xpay) {
        this.userXpay.forEach(xpay => {
          if (xpay.pi_type_id !== XPAY_NON_VISIBLE_TYPE) dirs.push(i18n.topup_xpay({name: xpay.name, mask_pan: xpay.mask_pan}))
        })
      }
      return dirs
    },
    directionOf (direction, value) {
      const dir = this.getDirections(direction)
      let idx = -1
      if (!Array.isArray(dir) && value === dir) {
        idx = 0
      } else if (Array.isArray(dir)) {
        idx = dir.indexOf(value)
      }
      return idx
    },
    async getFees () {
      try {
        const fees = await feeService.loadWithdrawalFeeByAmount(this.form.tokenCode, this.form.amount)
        this.fixedFee = this.commissions ? 0 : fees.fixed
        this.percentFee = this.commissions ? 0 : fees.percent
        this.isFeesLoadFailed = false
      } catch (err) {
        this.isFeesLoadFailed = true
        EventDispatcher.dispatchShowErrorEvent('Failed to load fees')
      }
      this.isFeesLoadPending = false
    },
    tryGetFees () {
      this.isFeesLoadPending = true
      if (!this.feesDebouncedRequest) {
        this.feesDebouncedRequest = debounce(() => this.getFees(), 300)
      }
      return this.feesDebouncedRequest()
    },

    updateView (mode, opts = {}, clear = false) {
      this.view.mode = mode
      this.view.opts = opts
      if (clear) {
        this.clear()
        this.setTokenCode()
      }
    },
    setTokenCode () {
      // Route params are untrusted: accept only tokens the user actually holds,
      // otherwise grey/unheld codes would crash the crypto card computeds
      const routeToken = this.$route.params.tokenCode
      this.form.tokenCode = (this.tokenCodes.includes(routeToken) ? routeToken : null) ||
        this.tokenCodes[this.tokenCodes.indexOf('UAH')] || null
    },
    setDefaultDirection (code) {
      let dir = this.TOP_UP_BALANCE_DIRECTION.nothere
      if (code === 'UAHX') {
        // eslint-disable-next-line no-unused-vars
        dir = this.getDirections(this.TOP_UP_BALANCE_DIRECTION.cashbox)
      } else {
        dir = this.getDirections(code === 'UAH' && this.userTaurus.length > 0
            ? this.TOP_UP_BALANCE_DIRECTION.ucash
            : (code === 'UAH' && this.userUplataInsha.length > 0
                ? this.TOP_UP_BALANCE_DIRECTION.uplataInsha
                : (this.isCashable()
                    ? this.TOP_UP_BALANCE_DIRECTION.cashbox
                    : this.TOP_UP_BALANCE_DIRECTION.nothere)))
      }
      this.form.direction = Array.isArray(dir) ? dir[0] : dir
    },
    assetIcon (asset) {
      return CurrencyHelper.getCurrencyIcon(asset)
    },
    async loadSelectedAssetMinAmount (asset) {
      const minAmount = await limitsService.loadDepositMinAmount(asset)
      if (minAmount) this.$set(this.minAmounts, asset, minAmount)
    },
    async setCryptoAddres (tokenCode, counter = 0) {
      this.cryptoAddres = ''
      this.noAddres = false
      if (tokenCode === CRYPTO_CURRENCYS.BTC || tokenCode === CRYPTO_CURRENCYS.ETH) {
        try {
          const cryptoAddres = await usersService.cryptoAdress(tokenCode.toString().toLowerCase() + '_wallet')
          if (cryptoAddres['address'] === '' && counter < 5) {
            setTimeout(() => this.setCryptoAddres(tokenCode, counter), 5000)
          } else if (cryptoAddres['address'] === '' && counter === 5) {
            EventDispatcher.dispatchShowErrorEvent(i18n.topup_failed_get_address())
            this.noAddres = true
          } else {
            this.cryptoAddres = cryptoAddres['address']
          }
          counter++
        } catch (e) {
          this.noAddres = true
          EventDispatcher.dispatchShowErrorEvent(i18n.topup_failed_get_address())
        }
      }
    }
  },
  watch: {
    'form.amount' (value) {
      if (!+this.form.amount) return
      if (this.form.tokenCode === 'UAH') {
        let fsum = parseFloat(this.form.amount)
        this.remainder = (fsum - Math.floor(fsum)) * 100
      } else {
        this.remainder = 0
      }
      if (value === '' || value < this.minAmounts[this.form.tokenCode]) {
        this.fixedFee = '0.0000'
        this.percentFee = '0.0000'
        return
      }
      this.tryGetFees()
    },
    async 'form.tokenCode' (value) {
      if (isCryptoToken(value) && !this.timer) {
        this.resetQr()
      }
      await this.loadSelectedAssetMinAmount(value)
      // if (!this.isHasMain) {
      //   this.createWallet()
      // }
      if (!+this.form.amount) return
      this.tryGetFees()
      this.setCryptoAddres(value)
      this.setDefaultDirection(value)
    },
    'form.direction' (value) {
      let idx = -1
      if ((idx = this.directionOf(this.TOP_UP_BALANCE_DIRECTION.ucash, value)) !== -1) {
        this.form.wallet = this.userTaurus[idx].id
      } else if ((idx = this.directionOf(this.TOP_UP_BALANCE_DIRECTION.uplataInsha, value)) !== -1) {
        this.form.wallet = this.userUplataInsha[idx].id
      } else if ((idx = this.directionOf(this.TOP_UP_BALANCE_DIRECTION.xpay, value)) !== -1) {
        this.form.wallet = this.userXpay[idx].cc_uuid
      } else if (this.directionOf(this.TOP_UP_BALANCE_DIRECTION.external, value) === -1) {
        this.form.wallet = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';
  .w-100 {
    width: 100%;
  }
  .timer-wrap {
    margin-bottom: 30px;
  }
  .wrapform {
    display: flex;
    justify-content: space-between;
  }
  .create-btn {
    min-width: 176px;
    margin-top: 10px;

    .md-button-content:has(.md-progress-spinner) {
      margin-top: 4px;
    }
  }
  .withdraw__user-balance {
    margin-bottom: 24px;
    color: $default-black;
  }

  .cash-header {
    font-weight: 600;
  }

  .withdraw__explanations {
    margin-bottom: 24px;
    line-height: 28px;
  }

  .withdraw__flex-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .withdraw__select,
  .withdraw__field {
    width: 47%;
    flex: none;
  }

  .withdraw__field {
    position: relative;
  }

  .withdraw__fees-container {
    color: $col-text-secondary;

    &.loading {
      opacity: .7;
    }

    .fee__fee-type {
      color: $col-active;
    }
  }

  .withdraw__fee-error {
    position: absolute;
    right: -60%;
  }

  .md-field.md-theme-default.md-invalid.md-focused label {
    border-color: $col-invalid;
  }

  .withdraw__success-msg {
    text-align: center;
  }

  .withdraw__success-amount {
    color: $col-md-primary;
    font-size: 22px;
    margin: 1rem 0 .5rem;
  }
  .bold {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/topupBalance/make/TopupBalance.Make.vue